import { selector } from "recoil";
import organizationDataState from "./organizationDataAtom";


const defaultLimit = 1000000;

const fileUploadLimitSelector = selector({
  key: "fileUploadLimitSelector",
  default: defaultLimit,
  get: ({ get }) => {
    const organizationData = get(organizationDataState);
    let limit = defaultLimit;
    
    // Handle case where organizationData is null or doesn't have account
    if (organizationData?.account?.fileUploadLimit) {
      limit = organizationData.account.fileUploadLimit;
    }
    
    return limit;
  },
});

export default fileUploadLimitSelector;
